import { DeckLayer } from '@deck.gl/arcgis';
import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import { useEffect, useState } from 'react';
import { ESRI, GOOGLE } from '@rsos/maps/constants/mapProviders';
import exportToGlobalNamespace from '@rsos/utils/exportToGlobalNamespace';
import DeckOverlay from './DeckOverlay';

const useDeckOverlay = mapProvider => {
  // Holds reference to the provider's overlay.
  const [overlay, setOverlay] = useState(null);

  // Holds the unified overlay adapter.
  const [deckOverlay, setDeckOverlay] = useState(null);

  useEffect(() => {
    if (overlay) {
      const deckOverlay = new DeckOverlay(mapProvider, overlay);
      setDeckOverlay(deckOverlay);
    }
  }, [overlay, mapProvider]);

  const createOverlay = (handleWebGLInitialized = () => {}) => {
    switch (mapProvider) {
      case ESRI: {
        return new DeckLayer();
      }
      case GOOGLE: {
        const overlay = new GoogleMapsOverlay({
          useDevicePixels: 2,
          onWebGLInitialized: gl => {
            handleWebGLInitialized(overlay, gl);
          },
        });
        return overlay;
      }
      default: {
        return null;
      }
    }
  };

  const handleOverlayCreation = async () => {
    const overlay = await createOverlay(handleWebGLInitialized);
    setOverlay(overlay);
    exportToGlobalNamespace('deckgl', overlay);
  };

  // TODO: This might only work for GMaps. Check
  // if this works for ESRI as well. For example,
  // what type is o?
  const handleWebGLInitialized = (o, gl) => {
    gl?.canvas?.addEventListener(
      'webglcontextlost',
      () => {
        o.setMap(null);
        o.finalize();
        handleOverlayCreation();
      },
      false,
    );
  };

  useEffect(() => {
    handleOverlayCreation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return deckOverlay;
};

export default useDeckOverlay;
